import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface AppLayoutProps {
  children: React.ReactNode;
  onLogout: () => void;
}
export function AppLayout({
  children,
  onLogout
}: AppLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-gray-50" data-id="element-61">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} data-id="element-62" />
      <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} onLogout={onLogout} data-id="element-63" />

      {/* Overlay for mobile */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-64" />}

      {/* Main Content Area */}
      <main className="lg:ml-64 pt-16 min-h-screen" data-id="element-65">
        <div className="p-4 lg:p-6" data-id="element-66">{children}</div>
      </main>
    </div>;
}